import Router from 'vue-router'
import Vue  from 'vue'
Vue.use(Router)

const routes = [
  // {
  //   path: '/',
  //   redirect: '/home',
  // },
  { path: '*', redirect: '/login' },
  {
    path: '/test',
    name: 'Test',
    component: () => import('@/views/test/index.vue'),
  },
  {
    path: '/dashboard',
    name: 'Dashboard',
    component: () => import('@/views/dashboard/index.vue'),
    meta: { title: 'Dashboard' },
  },
  {
    path: '/ota',
    name: 'Ota',
    component: () => import('@/views/ota/index.vue'),
    meta: { title: 'OTA' },
  },
  {
    path: '/wire',
    name: 'Wire',
    component: () => import('@/views/wireController/index.vue'),
    meta: { title: 'Wire' },
  },
  {
    path: '/login',
    name: 'Login',
    component: () => import('@/views/login/index.vue'),
    meta: { title: 'Heat Pump Dashboard' },
  },
  {
    path: '/home',
    name: 'Home',
    component: () => import('@/views/bigScreen_2025/complex-view/home/home.vue'),
    meta: { title: 'Heat Pump Dashboard' },
  },
  {
    path: '/bigScreen',
    name: 'BigScreen',
    component: () => import('@/views/bigScreen_2025/index.vue'),
    meta: { title: 'Heat Pump Dashboard' },
  },
  {
    path: '/poolFiltration',
    name: 'PoolFiltration',
    component: () => import('@/views/bigScreen_2025/complex-view/poolFiltration/poolFiltration.vue'),
    meta: { title: 'Pool control system' },
  },
  {
    path: '/analysis-report',
    name: 'AnalysisReport',
    component: () => import('@/views/bigScreen_2025/analysis-report/index.vue'),
    meta: { title: 'analysis report' },
  },
  {
    path: '/cascade',
    name: 'Cascade',
    component: () => import('@/views/cascade/index.vue'),
    meta: { title: 'Cascade' },
  },
  {
    path: '/pool-ecosystem',
    alias: '/smart-pool-ecosystem',
    name: 'PoolEcosystem',
    component: () => import('@/views/bigScreen_2025/smart-pool-ecosystem/index.vue'),
    meta: { title: 'Smart Pool Ecosystem' },
  },
];

const router = new Router({
  mode: 'history',
  base: '/',
  scrollBehavior: () => ({ y: 0 }),
  routes,
});

router.beforeEach((to, form, next) => {
  if (to.name === 'BigScreen') {
    document.getElementsByTagName('title')[0].innerHTML = to.query.productType === 'P-SP-HP' ? 'PV Pool Heat Pump System' : 'PV Water Heating System';
  } else {
    document.getElementsByTagName('title')[0].innerHTML = `${to.meta.title}`;
  }
  next();
});

export default router   